/**
 * Default landing after a successful sign-in when the opener doesn't specify
 * one — the transcripts home (我的逐字稿).
 *
 * Kept in its own module (deliberately NO `'use client'`) so server components
 * and pure routing helpers can import it without pulling in the client-only
 * auth-modal component graph.
 */
export const DEFAULT_POST_AUTH_DESTINATION = '/app/transcriptions'
